import { FlowEntry, FlowProgressWithSteps } from 'utils/FlowProvider/types'

export const NavSteps: (entry: FlowEntry, props: any) => FlowProgressWithSteps = entry => {
  const steps = [{ label: '' }, { label: '' }, { label: '' }, { label: '' }, { label: '' }]
  return { ...entry.progress, steps }
}
